import { MultipleViewTypeListActiveItemPreviewCloseButton } from '../../../MultipleViewTypeList'
import { PageEmptyState } from '../../../PageEmptyState'

import * as styles from './IntegrationsPreviewEmpty.module.css'

function IntegrationsPreviewEmpty({ onClosePreview, ...emptyStateProps }) {
  return (
    <div className={styles.IntegrationsPreviewEmpty}>
      <MultipleViewTypeListActiveItemPreviewCloseButton
        className={styles.close}
        onClose={onClosePreview}
      />
      <PageEmptyState {...emptyStateProps} className={styles.emptyState} />
    </div>
  )
}

export default IntegrationsPreviewEmpty
